module.exports = "<router-outlet (deactivate)=\"onDeactivate()\"></router-outlet>\n<div class=\"loading\" style=\"display:none\"><i class=\"fa fa-circle-o-notch fa-spin fa-3x\"></i></div>"


//////////////////
// WEBPACK FOOTER
// D:/wamp/www/sportal/pmi/web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main